import { API_URL as API, BACKEND_URL } from '../utils/config';
import React, { useState, useEffect } from 'react';
import axios from 'axios';


const DirectAdmin = () => {
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [message, setMessage] = useState('');
  const [formData, setFormData] = useState({
    name_en: '',
    name_no: '',
    description_en: '',
    description_no: '',
    category: 'foundation',
    price_nok: '',
    image_url: '',
    in_stock: true,
    featured: true
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API}/products`);
      setProducts(response.data);
    } catch (error) {
      setMessage('Error fetching products: ' + error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        price_nok: parseFloat(formData.price_nok),
        shades: []
      };

      // Call create endpoint with secret
      const response = await axios.post(
        `${API}/products?secret=cosmobeauty2025`,
        payload
      );
      
      setMessage('✅ Product added successfully!');
      setShowForm(false);
      resetForm();
      fetchProducts();
    } catch (error) {
      setMessage('❌ Error: ' + (error.response?.data?.detail || error.message));
    }
  };

  const resetForm = () => {
    setFormData({
      name_en: '',
      name_no: '',
      description_en: '',
      description_no: '',
      category: 'foundation',
      price_nok: '',
      image_url: '',
      in_stock: true,
      featured: true
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Direct Product Manager</h1>
        
        {message && (
          <div className="mb-4 p-4 bg-blue-100 border border-blue-300 rounded">
            {message}
          </div>
        )}

        {!showForm && (
          <button
            onClick={() => setShowForm(true)}
            className="mb-6 bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700"
          >
            Add New Product
          </button>
        )}

        {showForm && (
          <div className="bg-white p-6 rounded shadow-md mb-6">
            <h2 className="text-2xl font-bold mb-4">Add Product</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block mb-1 font-medium">Name (English)</label>
                  <input
                    type="text"
                    value={formData.name_en}
                    onChange={(e) => setFormData({...formData, name_en: e.target.value})}
                    required
                    className="w-full border px-3 py-2 rounded"
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium">Name (Norwegian)</label>
                  <input
                    type="text"
                    value={formData.name_no}
                    onChange={(e) => setFormData({...formData, name_no: e.target.value})}
                    required
                    className="w-full border px-3 py-2 rounded"
                  />
                </div>
              </div>

              <div>
                <label className="block mb-1 font-medium">Description (English)</label>
                <textarea
                  value={formData.description_en}
                  onChange={(e) => setFormData({...formData, description_en: e.target.value})}
                  required
                  rows="3"
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium">Description (Norwegian)</label>
                <textarea
                  value={formData.description_no}
                  onChange={(e) => setFormData({...formData, description_no: e.target.value})}
                  required
                  rows="3"
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block mb-1 font-medium">Category</label>
                  <input
                    type="text"
                    value={formData.category}
                    onChange={(e) => setFormData({...formData, category: e.target.value})}
                    required
                    className="w-full border px-3 py-2 rounded"
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium">Price (NOK)</label>
                  <input
                    type="number"
                    value={formData.price_nok}
                    onChange={(e) => setFormData({...formData, price_nok: e.target.value})}
                    required
                    step="0.01"
                    className="w-full border px-3 py-2 rounded"
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium">Image URL</label>
                  <input
                    type="url"
                    value={formData.image_url}
                    onChange={(e) => setFormData({...formData, image_url: e.target.value})}
                    required
                    className="w-full border px-3 py-2 rounded"
                  />
                </div>
              </div>

              <div className="flex gap-4">
                <button
                  type="submit"
                  className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
                >
                  Add Product
                </button>
                <button
                  type="button"
                  onClick={() => {setShowForm(false); resetForm();}}
                  className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-white rounded shadow-md overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="px-4 py-3 text-left">Product</th>
                <th className="px-4 py-3 text-left">Category</th>
                <th className="px-4 py-3 text-left">Price</th>
                <th className="px-4 py-3 text-left">Stock</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={product.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <img src={product.image_url} alt={product.name_en} className="w-12 h-12 object-contain" />
                      <div>
                        <p className="font-medium">{product.name_en}</p>
                        <p className="text-sm text-gray-600">{product.name_no}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">{product.category}</td>
                  <td className="px-4 py-3">{product.price_nok} NOK</td>
                  <td className="px-4 py-3">
                    <span className={product.in_stock ? 'text-green-600' : 'text-red-600'}>
                      {product.in_stock ? 'In Stock' : 'Out of Stock'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DirectAdmin;
